export default __webpack_public_path__ + "static/media/1416.c395ae37.png";